// extracted by mini-css-extract-plugin
export default {"addon":"addon__Hnpv5"};